import React from 'react';

import useDutchiePayEnrollment from 'hooks/use-dutchiePay-enrollment';
import { ExistingUser } from 'src/account/bank-account/components/existing-user';
import { useDutchiePay } from 'src/payments/hooks';
import { useOpenDutchiePay } from 'src/payments/hooks/use-open-dutchie-pay/use-open-dutchie-pay';
import { editBankAccount } from 'src/payments/constants';

import { WalletSection } from 'src/components/wallet/wallet-section';

import PlusSymbol from 'src/assets/plus-symbol';
import {
  AddBankCard,
  AddBankCardButton,
  AddBankIconSquare,
  AddBankSubtitle,
  AddBankText,
  AddBankTitle,
  ChevronRight,
  MarqueeWrapper,
} from './linked-bank-section.styles';

const BankLogosMarqueeWide = React.lazy(() =>
  import('src/components/wallet/bank-logos-marquee-wide').then((module) => ({ default: module.BankLogosMarqueeWide }))
);

export const LinkedBankSection = (): JSX.Element => {
  const { activeBankAccount } = useDutchiePay();
  const DutchiePayEnrollment = useDutchiePayEnrollment();
  const { openDutchiePay } = useOpenDutchiePay({ step: editBankAccount });

  const handleAddBankClick = (): void => {
    openDutchiePay(editBankAccount);
    DutchiePayEnrollment.editBankAccount();
  };

  return (
    <WalletSection title='Linked bank'>
      {activeBankAccount ? (
        <ExistingUser hideHeader />
      ) : (
        <AddBankCard>
          <AddBankCardButton type='button' onClick={handleAddBankClick}>
            <AddBankIconSquare aria-hidden>
              <PlusSymbol width={14} height={14} fill='currentColor' />
            </AddBankIconSquare>
            <AddBankText>
              <AddBankTitle size='small' weight='bold' tag='span'>
                Add a bank
              </AddBankTitle>
              <AddBankSubtitle size='xsmall' tag='span'>
                Pay direct or fund your wallet
              </AddBankSubtitle>
            </AddBankText>
            <ChevronRight aria-hidden />
          </AddBankCardButton>
          <MarqueeWrapper>
            <React.Suspense fallback={<div style={{ height: '48px' }} />}>
              <BankLogosMarqueeWide />
            </React.Suspense>
          </MarqueeWrapper>
        </AddBankCard>
      )}
    </WalletSection>
  );
};
